import data from "./data.js";
import update from "./update.js";
import create from "./create.js";
import get from "./get.js";
import has from "./has.js";

export { data, update, create, get, has };
export default { data, update, create, get, has };
